import { InputTaskCategory } from 'interfaces/IInputTask';

import { RootState } from '../Store';

export const getSelectedInputId = (state: RootState): string | null =>
  state.inputReducer.selectedInputId;

export const getActiveTaskCategory = (state: RootState): InputTaskCategory =>
  state.inputReducer.activeTaskCategory;

export const getHasUnsavedInputChanges = (state: RootState): boolean =>
  state.inputReducer.hasUnsavedChanges;

export const getInputDraftReloadKey = (state: RootState): number =>
  state.inputReducer.inputDraftReloadKey;
